import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardText, CardTitle } from "reactstrap";
import { DateHelper } from "@workspace/common";

function ClientJobTab({ jobData }) {
  const [job, setJob] = useState(null);
  useEffect(() => {
    if (jobData) {
      setJob(jobData?.jobSubmissionData);
    }
  }, [jobData]);

  return (
    <div className="px-0 py-3" style={{ height: "100vh" }}>
      <Card className="shadow-none">
        <Row className="mx-0 mb-3">
          <Col className="d-flex align-items-center justify-content-between px-0">
            <div className="d-flex align-items-center">
              <i className="las la-map-marker me-1" />
              <CardText className="color-slategray">
                {job?.country}, {job?.workLocation}
              </CardText>
            </div>
          </Col>
        </Row>
        <Row className="d-flex align-items-start m-0 py-2 bg-light rounded mb-3">
          <Col className="flex-center-column" xs="4" md="2">
            <div className="d-flex align-items-center">
              <i className="ri-briefcase-line" />
            </div>
            <small className="color-slategray">JOB ID</small>
            <h6 className="mt-1">{job?.jobId}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" md="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-calendar-blank-outline" />
            </div>
            <small className="color-slategray">DATE POSTED</small>
            <h6 className="mt-1">
              {DateHelper.formatDateStandard2(job?.dateOpen)}
            </h6>
          </Col>
          <Col className="flex-center-column" xs="4" md="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-timer-outline" />
            </div>
            <small className="color-slategray">JOB EXPIRE IN</small>
            <h6 className="mt-1">
              {DateHelper.formatDateStandard2(job?.targetClosingDate)}
            </h6>
          </Col>
          <Col className="flex-center-column" xs="4" md="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-layers-triple-outline" />
            </div>
            <small className="color-slategray">WORK MODE</small>
            <h6 className="mt-1">{job?.workType}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" md="2">
            <div className="d-flex align-items-center">
              <i className="ri-wallet-line" />
            </div>
            <small className="color-slategray">SALARY</small>
            <h6 className="mt-1">{job?.payrate}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" md="2">
            <div className="d-flex align-items-center">
              <i className="ri-building-line" />
            </div>
            <small className="color-slategray">JOB-TYPE</small>
            <h6 className="mt-1">{job?.jobType}</h6>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 className="fw-light">Job Description</h5>
          </Col>
        </Row>

        <Row>
          <Col>
            <div
              className="fs-15 color-blackcoral"
              dangerouslySetInnerHTML={{ __html: job?.Jobdescription }}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default ClientJobTab;
